function busMouse() {

  window.mm = {
    isClick : false,
    down : false,
    posStart : {
      date: null,
      x: 0,
      y: 0
    },
    posEnd : {
      date: null,
      x: 0,
      y: 0
    },
    posCurrent : {
      x: window.ww/2,
      y: window.wh/2
    },
    posDrag : {
      x: 0,
      y: 0
    },
    targetMouseClick : null,
    targetMouseMove : null,

    speed : {
      x: 0,
      y: 0,
      xy: 0,
    }
  }

  function mouseTracking(){
    let isTouching = false;

    function onStart(e) {
      if (e.type === 'mousedown' && isTouching) return;

      if (e.type === 'touchstart') {
        isTouching = true;
        setTimeout(() => { isTouching = false }, 500); // évite les ghost mousedown
      }

      mm.down = true;
      mm.posStart.x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      mm.posStart.y = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
      mm.posStart.date = new Date();

      mm.targetMouseClick = e.target;

      bus.emit("cursorStart");
    }

    function onEnd(e) {
      if (e.type === 'mouseup' && isTouching) return;

      mm.down = false;
      mm.posEnd.x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      mm.posEnd.y = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
      mm.posEnd.date = new Date();

      mm.isClick =
        Math.abs(mm.posDrag.x) < 10 &&
        Math.abs(mm.posDrag.y) < 10 &&
        mm.posEnd.date - mm.posStart.date < 300;

      if (mm.isClick) {
        bus.emit("click", mm.targetMouseClick);
      }

      bus.emit("cursorEnd");
    }
    function onMove(e) {
      mm.posCurrent.x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      mm.posCurrent.y = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;

      mm.targetMouseMove = e.target

      mm.posDrag.x = mm.down ? mm.posStart.x - mm.posCurrent.x : 0
      mm.posDrag.y = mm.down ? mm.posStart.y - mm.posCurrent.y : 0

      bus.emit("cursorMove")
    }

    window.addEventListener('touchstart', onStart, {passive: true})
    window.addEventListener('mousedown', onStart, {passive: true})
    //$(window).on('touchstart mousedown', onStart)

    window.addEventListener('touchend', onEnd, {passive: true})
    window.addEventListener('mouseup', onEnd, {passive: true})
    //$(window).on('touchend mouseup', onEnd)

    window.addEventListener('touchmove', onMove, {passive: true})
    window.addEventListener('mousemove', onMove, {passive: true})
    //$(window).on('mousemove touchmove', onMove)
  }
  mouseTracking()

  function mouseSpeed(){
    let leTimestamp = null
    let lastX
    let currentX
    let speedX = 0

    let lastY
    let currentY
    let speedY = 0

    let speedXY = 0

    function raf() {
      currentX = window.mm.posCurrent.x
      currentY = window.mm.posCurrent.y

      // get inertia
      if (leTimestamp === null) {
        leTimestamp = Date.now();
        lastX = currentX;
        lastY = currentY;
        return;
      }
      let now = Date.now();
      let dt =  now - leTimestamp;

      // x
      let dX = currentX - lastX;
      speedX = dt === 0 ? 0 : dX / dt;
      lastX = currentX;

      // y
      let dY = currentY - lastY;
      speedY = dt === 0 ? 0 : dY / dt;
      lastY = currentY;

      leTimestamp = now;

      speedXY = speedX*speedY

      // update values
      window.mm.speed.x = speedX
      window.mm.speed.y = speedY
      window.mm.speed.xy = speedXY
    }

    bus.on('raf', raf)
  }
  mouseSpeed()

}

export default busMouse